import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    addViewClaims,
    isRecentBatch
} from "~/app/submit_claims/upload/actions";


class newCMS1500 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            claim: null,
            fields: {
                pat_name_f: null,
                pat_name_l: null,
                pat_sex: null,
                pat_dob: null,
                pat_addr_1: null,
                pat_addr_2: null,
                pat_state: null,
                pat_city: null,
                pat_zip: null,
                pat_phone: null,

                from_date_1: null,
                from_date_2: null,
                from_date_3: null,
                from_date_4: null,
                from_date_5: null,

                diag_1: null,
                diag_2: null,
                diag_3: null,
                diag_4: null,
                diag_5: null,

                diag_ref_1: null,
                diag_ref_2: null,
                diag_ref_3: null,
                diag_ref_4: null,
                diag_ref_5: null,

                proc_code_1: null,
                proc_code_2: null,
                proc_code_3: null,
                proc_code_4: null,
                proc_code_5: null,

                mod1_1: null,
                mod1_2: null,
                mod1_3: null,
                mod1_4: null,
                mod1_5: null,

                units_1: null,
                units_2: null,
                units_3: null,
                units_4: null,
                units_5: null,

                charge_1: null,
                charge_2: null,
                charge_3: null,
                charge_4: null,
                charge_5: null,

                place_of_service_1: null,
                place_of_service_2: null,
                place_of_service_3: null,
                place_of_service_4: null,
                place_of_service_5: null,

                payerid: null,
                payer_name: null,
                ins_number: null,
                prior_auth: null,

                bill_name: null,
                bill_addr_1: null,
                bill_addr_2: null,
                bill_city: null,
                bill_state: null,
                bill_zip: null,
                bill_phone: null,
                bill_npi: null,
                bill_id: null,

                bill_taxid: null,
                bill_taxid_type: null,
                accept_assign: null,
                total_charge: null,
                amount_paid: null
            },
            errors: {
                pat_name_f: false,
                pat_name_l: false,
                pat_sex: false,
                pat_dob: false,
                pat_addr_1: false,
                pat_addr_2: false,
                pat_state: false,
                pat_city: false,
                pat_zip: false,
                pat_phone: false,

                from_date_1: false,
                from_date_2: false,
                from_date_3: false,
                from_date_4: false,
                from_date_5: false,

                diag_1: false,
                diag_2: false,
                diag_3: false,
                diag_4: false,
                diag_5: false,

                diag_ref_1: false,
                diag_ref_2: false,
                diag_ref_3: false,
                diag_ref_4: false,
                diag_ref_5: false,

                proc_code_1: false,
                proc_code_2: false,
                proc_code_3: false,
                proc_code_4: false,
                proc_code_5: false,

                mod1_1: false,
                mod1_2: false,
                mod1_3: false,
                mod1_4: false,
                mod1_5: false,

                units_1: false,
                units_2: false,
                units_3: false,
                units_4: false,
                units_5: false,

                charge_1: false,
                charge_2: false,
                charge_3: false,
                charge_4: false,
                charge_5: false,

                place_of_service_1: false,
                place_of_service_2: false,
                place_of_service_3: false,
                place_of_service_4: false,
                place_of_service_5: false,

                payerid: false,
                payer_name: false,
                ins_number: false,
                prior_auth: false,

                bill_name: false,
                bill_addr_1: false,
                bill_addr_2: false,
                bill_city: false,
                bill_state: false,
                bill_zip: false,
                bill_phone: false,
                bill_npi: false,
                bill_id: false,

                bill_taxid: false,
                bill_taxid_type: false,
                accept_assign: false,
                total_charge: false,
                amount_paid: false
            }
        };
    }

    // render() {
    //     return (
    //         <div>
    //             <SkyLight
    //                 hideOnOverlayClicked
    //                 ref={ref => (this.simpleDialog = ref)}
    //                 dialogStyles={dialog}
    //             >
    //                 <div>
    //                     {/* <div className="modal-header">
    //                         <div className="modal-header-title">Edit Claim</div>
    //                         <div className="modal-header-subtitle">Fix or View Claim</div>
    //                     </div> */}

    //                     <div className="form-col">
    //                         <form>
    //                             <div>
    //                                 <fieldset className="claim-info">
    //                                     <div>
    //                                         <label htmlFor="payer_name">Payer Name</label>
    //                                         <input
    //                                             autoComplete="off"
    //                                             className={"claim-input"}
    //                                             type="text"
    //                                             id="payer_name"
    //                                             value={this.state.fields.payer_name}
    //                                             onChange={e => this.handleChange(e, "payer_name")}
    //                                         />
    //                                         <label htmlFor="payerid">PayerID</label>
    //                                         <input
    //                                             autoComplete="off"
    //                                             className={"claim-input "}
    //                                             type="text"
    //                                             id="payerid"
    //                                             value={this.state.fields.payerid}
    //                                             onChange={e => this.handleChange(e, "payerid")}
    //                                         />
    //                                         <label htmlFor="payer_order">Type</label>
    //                                         <input
    //                                             autoComplete="off"
    //                                             className={"claim-input "}
    //                                             type="text"
    //                                             id="payer_order"
    //                                             value={this.state.fields.payer_order}
    //                                             onChange={e => this.handleChange(e, "payer_order")}
    //                                         />
    //                                         {/* 

    //                                         <label htmlFor="prior_auth">Prior Authorization #</label>
    //                                         <input
    //                                             autoComplete="off"
    //                                             className={"claim-input"}
    //                                             type="text"
    //                                             id="prior_auth"
    //                                             value={this.state.fields.prior_auth}
    //                                             onChange={e => this.handleChange(e, "prior_auth")}
    //                                         /> */}
    //                                     </div>
    //                                 </fieldset>
    //                                 <div className="pat-box">
    //                                     <label htmlFor="ins_number">Insured ID Number</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input "}
    //                                         type="text"
    //                                         id="ins_number"
    //                                         value={this.state.fields.ins_number}
    //                                         onChange={e => this.handleChange(e, "ins_number")}
    //                                     /></div>

    //                                 <div id="pat-info" className="pat-box">
    //                                     <fieldset className="pat-loc-info">
    //                                         <div>


    //                                             <label htmlFor="ins_name_l">Last Name</label>
    //                                             <input
    //                                                 autoComplete="off"
    //                                                 className={"claim-input"}
    //                                                 type="text"
    //                                                 id="ins_name_l"
    //                                                 value={this.state.fields.ins_name_l}
    //                                                 onChange={e => this.handleChange(e, "ins_name_l")}
    //                                             />
    //                                             <label htmlFor="ins_name_f">First Name</label>
    //                                             <input
    //                                                 autoComplete="off"
    //                                                 className={"claim-input"}
    //                                                 type="text"
    //                                                 id="ins_name_f"
    //                                                 value={this.state.fields.ins_name_f}
    //                                                 onChange={e => this.handleChange(e, "ins_name_f")}
    //                                             />
    //                                         </div>
    //                                         <div>
    //                                             <label htmlFor="ins_dob">Date of Birth</label>
    //                                             <input
    //                                                 autoComplete="off"
    //                                                 className={"claim-input claim-input-small"}
    //                                                 type="text"
    //                                                 id="ins_dob"
    //                                                 value={this.state.fields.ins_dob}
    //                                                 onChange={e => this.handleChange(e, "ins_dob")}
    //                                             />
    //                                             <label htmlFor="ins_sex">Sex</label>
    //                                             <input
    //                                                 autoComplete="off"
    //                                                 className={"claim-input claim-input-xsmall"}
    //                                                 type="text"
    //                                                 id="ins_sex"
    //                                                 value={this.state.fields.ins_sex}
    //                                                 onChange={e => this.handleChange(e, "ins_sex")}
    //                                             />
    //                                             <label htmlFor="ins_phone">Phone Number</label>
    //                                             <input
    //                                                 autoComplete="off"
    //                                                 className={"claim-input"}
    //                                                 type="text"
    //                                                 id="ins_phone"
    //                                                 value={this.state.fields.ins_phone}
    //                                                 onChange={e => this.handleChange(e, "ins_phone")}
    //                                             />
    //                                         </div>

    //                                         <div>
    //                                             <label htmlFor="ins_addr_1">Address</label>
    //                                             <input
    //                                                 autoComplete="off"
    //                                                 className={"claim-input"}
    //                                                 type="text"
    //                                                 id="ins_addr_1"
    //                                                 value={this.state.fields.ins_addr_1}
    //                                                 onChange={e => this.handleChange(e, "ins_addr_1")}
    //                                             />

    //                                             <label htmlFor="ins_city">City</label>
    //                                             <input
    //                                                 autoComplete="off"
    //                                                 className={"claim-input"}
    //                                                 type="text"
    //                                                 id="ins_city"
    //                                                 value={this.state.fields.ins_city}
    //                                                 onChange={e => this.handleChange(e, "ins_city")}
    //                                             />
    //                                         </div>
    //                                         <div>
    //                                             <label htmlFor="ins_state">State</label>
    //                                             <input
    //                                                 autoComplete="off"
    //                                                 className={"claim-input claim-input-xsmall"}
    //                                                 type="text"
    //                                                 id="ins_state"
    //                                                 value={this.state.fields.ins_state}
    //                                                 onChange={e => this.handleChange(e, "ins_state")}
    //                                             />

    //                                             <label htmlFor="ins_zip">Zip</label>
    //                                             <input
    //                                                 autoComplete="off"
    //                                                 className={"claim-input claim-input-small"}
    //                                                 type="text"
    //                                                 id="ins_zip"
    //                                                 value={this.state.fields.ins_zip}
    //                                                 onChange={e => this.handleChange(e, "ins_zip")}
    //                                             />
    //                                         </div>
    //                                     </div>
    //                                 </fieldset>
    //                             </div>

    //                             <div className="pat-prov-box">
    //                                 <div id="pat-info" className="pat-box">
    //                                     <fieldset className="pat-loc-info">
    //                                         <div>
    //                                             <div>

    //                                                 <label htmlFor="pat_name_l">Last Name</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input"}
    //                                                     type="text"
    //                                                     id="pat_name_l"
    //                                                     value={this.state.fields.pat_name_l}
    //                                                     onChange={e => this.handleChange(e, "pat_name_l")}
    //                                                 />
    //                                                 <label htmlFor="pat_name_f">First Name</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input"}
    //                                                     type="text"
    //                                                     id="pat_name_f"
    //                                                     value={this.state.fields.pat_name_f}
    //                                                     onChange={e => this.handleChange(e, "pat_name_f")}
    //                                                 />
    //                                             </div>
    //                                             <div>
    //                                                 <label htmlFor="pat_dob">Date of Birth</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input claim-input-small"}
    //                                                     type="text"
    //                                                     id="pat_dob"
    //                                                     value={this.state.fields.pat_dob}
    //                                                     onChange={e => this.handleChange(e, "pat_dob")}
    //                                                 />
    //                                                 <label htmlFor="pat_sex">Sex</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input claim-input-xsmall"}
    //                                                     type="text"
    //                                                     id="pat_sex"
    //                                                     value={this.state.fields.pat_sex}
    //                                                     onChange={e => this.handleChange(e, "pat_sex")}
    //                                                 />
    //                                                 <label htmlFor="pat_phone">Phone Number</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input"}
    //                                                     type="text"
    //                                                     id="pat_phone"
    //                                                     value={this.state.fields.pat_phone}
    //                                                     onChange={e => this.handleChange(e, "pat_phone")}
    //                                                 />
    //                                             </div>

    //                                             <div>
    //                                                 <label htmlFor="pat_addr_1">Address</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input"}
    //                                                     type="text"
    //                                                     id="pat_addr_1"
    //                                                     value={this.state.fields.pat_addr_1}
    //                                                     onChange={e => this.handleChange(e, "pat_addr_1")}
    //                                                 />

    //                                                 <label htmlFor="pat_city">City</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input"}
    //                                                     type="text"
    //                                                     id="pat_city"
    //                                                     value={this.state.fields.pat_city}
    //                                                     onChange={e => this.handleChange(e, "pat_city")}
    //                                                 />
    //                                             </div>
    //                                             <div>
    //                                                 <label htmlFor="pat_state">State</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input claim-input-xsmall"}
    //                                                     type="text"
    //                                                     id="pat_state"
    //                                                     value={this.state.fields.pat_state}
    //                                                     onChange={e => this.handleChange(e, "pat_state")}
    //                                                 />

    //                                                 <label htmlFor="pat_zip">Zip</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input claim-input-small"}
    //                                                     type="text"
    //                                                     id="pat_zip"
    //                                                     value={this.state.fields.pat_zip}
    //                                                     onChange={e => this.handleChange(e, "pat_zip")}
    //                                                 />
    //                                             </div>
    //                                         </div>
    //                                     </fieldset>
    //                                 </div>
    //                                 <div id="provider-info" className="provider-box">
    //                                     <fieldset className="pat-loc-info">
    //                                         <div>
    //                                             <div>
    //                                                 <label htmlFor="bill_name">Billing Provider</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input"}
    //                                                     type="text"
    //                                                     id="bill_name"
    //                                                     value={this.state.fields.bill_name}
    //                                                     onChange={e => this.handleChange(e, "bill_name")}
    //                                                 />
    //                                                 <label htmlFor="bill_addr_1">Address 1</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input"}
    //                                                     type="text"
    //                                                     id="bill_addr_1"
    //                                                     value={this.state.fields.bill_addr_1}
    //                                                     onChange={e => this.handleChange(e, "bill_addr_1")}
    //                                                 />
    //                                             </div>
    //                                             <div>
    //                                                 <label htmlFor="bill_addr_2">Address 2</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input claim-input-small"}
    //                                                     type="text"
    //                                                     id="bill_addr_2"
    //                                                     value={this.state.fields.bill_addr_2}
    //                                                     onChange={e => this.handleChange(e, "bill_addr_2")}
    //                                                 />
    //                                                 <label htmlFor="bill_city">City</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input "}
    //                                                     type="text"
    //                                                     id="bill_city"
    //                                                     value={this.state.fields.bill_city}
    //                                                     onChange={e => this.handleChange(e, "bill_city")}
    //                                                 />
    //                                                 <label htmlFor="bill_state">State</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input claim-input-xsmall"}
    //                                                     type="text"
    //                                                     id="bill_state"
    //                                                     value={this.state.fields.bill_state}
    //                                                     onChange={e => this.handleChange(e, "bill_state")}
    //                                                 />
    //                                             </div>

    //                                             <div>
    //                                                 <label htmlFor="bill_zip">Zip</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input claim-input-small "}
    //                                                     type="text"
    //                                                     id="bill_zip"
    //                                                     value={this.state.fields.bill_zip}
    //                                                     onChange={e => this.handleChange(e, "bill_zip")}
    //                                                 />

    //                                                 <label htmlFor="bill_phone">Phone</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input"}
    //                                                     type="text"
    //                                                     id="bill_phone"
    //                                                     value={this.state.fields.bill_phone}
    //                                                     onChange={e => this.handleChange(e, "bill_phone")}
    //                                                 />
    //                                             </div>
    //                                             <div>
    //                                                 <label htmlFor="bill_npi">NPI</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input "}
    //                                                     type="text"
    //                                                     id="bill_npi"
    //                                                     value={this.state.fields.bill_npi}
    //                                                     onChange={e => this.handleChange(e, "bill_npi")}
    //                                                 />

    //                                                 <label htmlFor="bill_id">Billing ID</label>
    //                                                 <input
    //                                                     autoComplete="off"
    //                                                     className={"claim-input claim-input-small"}
    //                                                     type="text"
    //                                                     id="bill_id"
    //                                                     value={this.state.fields.bill_id}
    //                                                     onChange={e => this.handleChange(e, "bill_id")}
    //                                                 />
    //                                             </div>
    //                                         </div>
    //                                     </fieldset>
    //                                 </div>

    //                             </div>

    //                             <div>
    //                                 <fieldset className="line-item">
    //                                     <label htmlFor={"from_date_1"}>Date of Service</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-small"}
    //                                         type="text"
    //                                         id={"from_date_1"}
    //                                         onChange={e => this.handleOnChange(e, "from_date_1")}
    //                                         value={this.state.fields["from_date_1"]}
    //                                     />
    //                                     <label htmlFor={"place_of_service_1"}>Place</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-xsmall"}
    //                                         type="text"
    //                                         id={"place_of_service_1"}
    //                                         onChange={e =>
    //                                             this.handleOnChange(e, "place_of_service_1")
    //                                         }
    //                                         value={this.state.fields["place_of_service_1"]}
    //                                     />
    //                                     <label htmlFor={"proc_code_1"}>Procedure Code</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-small"}
    //                                         type="text"
    //                                         id={"proc_code_1"}
    //                                         onChange={e => this.handleOnChange(e, "proc_code_1")}
    //                                         value={this.state.fields["proc_code_1"]}
    //                                     />
    //                                     <label htmlFor={"mod1_1"}>Modifier</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-xsmall"}
    //                                         type="text"
    //                                         id={"mod1_1"}
    //                                         onChange={e => this.handleOnChange(e, "mod1_1")}
    //                                         value={this.state.fields["mod1_1"]}
    //                                     />
    //                                     <label htmlFor={"diag_ref_1"}>Ref</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-xsmall"}
    //                                         type="text"
    //                                         id={"diag_ref_1"}
    //                                         onChange={e => this.handleOnChange(e, "diag_ref_1")}
    //                                         value={this.state.fields["diag_ref_1"]}
    //                                     />
    //                                     <label htmlFor={"charge_1"}>Charge</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-small"}
    //                                         type="text"
    //                                         id={"charge_1"}
    //                                         onChange={e => this.handleOnChange(e, "charge_1")}
    //                                         value={this.state.fields["charge_1"]}
    //                                     />
    //                                     <label htmlFor={"units_1"}>Units</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-xsmall"}
    //                                         type="text"
    //                                         id={"units_1"}
    //                                         onChange={e => this.handleOnChange(e, "units_1")}
    //                                         value={this.state.fields["units_1"]}
    //                                     />
    //                                 </fieldset>
    //                             </div>

    //                             <div />

    //                             <div>
    //                                 <fieldset className="line-item">
    //                                     <label htmlFor={"bill_taxid"}>Tax ID</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-small"}
    //                                         type="text"
    //                                         id={"bill_taxid"}
    //                                         onChange={e => this.handleOnChange(e, "bill_taxid")}
    //                                         value={this.state.fields["bill_taxid"]}
    //                                     />
    //                                     <label htmlFor={"bill_taxid_type"}>Tax Type</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-small"}
    //                                         type="text"
    //                                         id={"bill_taxid_type"}
    //                                         onChange={e => this.handleOnChange(e, "bill_taxid_type")}
    //                                         value={this.state.fields["bill_taxid_type"]}
    //                                     />
    //                                     <label htmlFor={"accept_assign"}>Accept Assign</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-small"}
    //                                         type="text"
    //                                         id={"accept_assign"}
    //                                         onChange={e => this.handleOnChange(e, "accept_assign")}
    //                                         value={this.state.fields["accept_assign"]}
    //                                     />
    //                                     <label htmlFor={"total_charge"}>Total Charge</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-small"}
    //                                         type="text"
    //                                         id={"total_charge"}
    //                                         onChange={e => this.handleOnChange(e, "total_charge")}
    //                                         value={this.state.fields["total_charge"]}
    //                                     />
    //                                     <label htmlFor={"amount_paid"}>Amount Paid</label>
    //                                     <input
    //                                         autoComplete="off"
    //                                         className={"claim-input claim-input-small"}
    //                                         type="text"
    //                                         id={"amount_paid"}
    //                                         onChange={e => this.handleOnChange(e, "amount_paid")}
    //                                         value={this.state.fields["amount_paid"]}
    //                                     />
    //                                 </fieldset>
    //                             </div>

    //                             {/* <LineItem data={this.state.claim} getLineItems={(fields, errors) => this.handleLineItemsChange(fields, errors)} getLineItemCount={(line_items) => this.handleLineItemCount(line_items)} /> */}
    //                         </form>
    //                     </div>

    //                     <div className="err-col" />

    //                     {/* {this.renderSaveButton()} */}
    //                 </div>
    //             </SkyLight>
    //         </div>
    //     );
    // }

    componentWillReceiveProps = nextProps => {
        if (nextProps.rowData !== this.props.rowData) {
            this.simpleDialog.show();
            console.log("claim data", nextProps.rowData);
            this.setState({
                claim: nextProps.rowData,
                fields: {
                    pat_name_f: nextProps.rowData.pat_name_f,
                    pat_name_l: nextProps.rowData.pat_name_l,
                    pat_sex: nextProps.rowData.pat_sex,
                    pat_dob: nextProps.rowData.pat_dob,
                    pat_addr_1: nextProps.rowData.pat_addr_1,
                    pat_addr_2: nextProps.rowData.pat_addr_2,
                    pat_state: nextProps.rowData.pat_state,
                    pat_city: nextProps.rowData.pat_city,
                    pat_zip: nextProps.rowData.pat_zip,
                    pat_phone: nextProps.rowData.pat_phone,

                    from_date_1: nextProps.rowData.from_date_1,
                    from_date_2: nextProps.rowData.from_date_2,
                    from_date_3: nextProps.rowData.from_date_3,
                    from_date_4: nextProps.rowData.from_date_4,
                    from_date_5: nextProps.rowData.from_date_5,

                    diag_1: nextProps.rowData.diag_1,
                    diag_2: nextProps.rowData.diag_2,
                    diag_3: nextProps.rowData.diag_3,
                    diag_4: nextProps.rowData.diag_4,
                    diag_5: nextProps.rowData.diag_5,

                    diag_ref_1: nextProps.rowData.diag_ref_1,
                    diag_ref_2: nextProps.rowData.diag_ref_2,
                    diag_ref_3: nextProps.rowData.diag_ref_3,
                    diag_ref_4: nextProps.rowData.diag_ref_4,
                    diag_ref_5: nextProps.rowData.diag_ref_5,

                    proc_code_1: nextProps.rowData.proc_code_1,
                    proc_code_2: nextProps.rowData.proc_code_2,
                    proc_code_3: nextProps.rowData.proc_code_3,
                    proc_code_4: nextProps.rowData.proc_code_4,
                    proc_code_5: nextProps.rowData.proc_code_5,

                    mod1_1: nextProps.rowData.mod1_1,
                    mod1_2: nextProps.rowData.mod1_2,
                    mod1_3: nextProps.rowData.mod1_3,
                    mod1_4: nextProps.rowData.mod1_4,
                    mod1_5: nextProps.rowData.mod1_5,

                    units_1: nextProps.rowData.units_1,
                    units_2: nextProps.rowData.units_2,
                    units_3: nextProps.rowData.units_3,
                    units_4: nextProps.rowData.units_4,
                    units_5: nextProps.rowData.units_5,

                    charge_1: nextProps.rowData.charge_1,
                    charge_2: nextProps.rowData.charge_2,
                    charge_3: nextProps.rowData.charge_3,
                    charge_4: nextProps.rowData.charge_4,
                    charge_5: nextProps.rowData.charge_5,

                    place_of_service_1: nextProps.rowData.place_of_service_1,
                    place_of_service_2: nextProps.rowData.place_of_service_2,
                    place_of_service_3: nextProps.rowData.place_of_service_3,
                    place_of_service_4: nextProps.rowData.place_of_service_4,
                    place_of_service_5: nextProps.rowData.place_of_service_5,

                    payerid: nextProps.rowData.payerid,
                    payer_name: nextProps.rowData.payer_name,
                    ins_number: nextProps.rowData.ins_number,
                    prior_auth: nextProps.rowData.prior_auth,

                    bill_name: nextProps.rowData.bill_name,
                    bill_addr_1: nextProps.rowData.bill_addr_1,
                    bill_addr_2: nextProps.rowData.bill_addr_2,
                    bill_city: nextProps.rowData.bill_city,
                    bill_state: nextProps.rowData.bill_state,
                    bill_zip: nextProps.rowData.bill_zip,
                    bill_phone: nextProps.rowData.bill_phone,
                    bill_npi: nextProps.rowData.bill_npi,
                    bill_id: nextProps.rowData.bill_id,

                    bill_taxid: nextProps.rowData.bill_taxid,
                    bill_taxid_type: nextProps.rowData.bill_taxid_type,
                    accept_assign: nextProps.rowData.accept_assign,
                    total_charge: nextProps.rowData.total_charge,
                    amount_paid: nextProps.rowData.amount_paid
                }
                //line_items: nextProps.rowData.line_items
            });

            //   this.highlightErrors(nextProps.rowData);
        }
    };

    handleChange = (event, field) => {
        let fields = this.state.fields;
        fields[field] = event.target.value;
        this.setState({ fields: fields }); //Update controlled states on change

        // //let classNames= this.state.classNames;
        // let claim = Object.assign({}, this.state.claim)
        // const index = _.findIndex(claim.error, error => {
        //   return error._attributes.fields === field;
        // });

        // if (index !== -1) {
        //   //remove errors if the current field is in the errors obj
        //   claim.error.splice(index, 1);
        // }

        // this.highlightErrors(claim);
        // this.setState({ fields: currentFields, claim });
        // this.claimFieldsCheck();
    };

    validate = (event, field) => { };
}
var dialog = {
    width: "fit-content",
    height: "700px",
    position: "fixed",
    top: "30%",
    left: "45%",
    marginTop: "-200px",
    marginLeft: "-25%",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    zIndex: "100",
    padding: "15px",
    boxShadow: "rgba(0, 0, 0, 0.14) 0px 0px 4px, rgba(0, 0, 0, 0.28) 0px 4px 8px",
    transform: "scale(1)",
    transitionProperty: "transform",
    transitionTimingFunction: "ease",
    transitionDuration: "5000ms",
    overflow: "auto"
};

const mapStateToProps = state => {
    return {};
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            addViewClaims: addViewClaims,
            isRecentBatch: isRecentBatch
        },
        dispatch
    );
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(newCMS1500);



// WEBPACK FOOTER //
// ./src/app/common/cms_1500/newCMS1500.js